import React from "react";
import { Columns3 } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "../ui/dropdown-menu";
import { COLUMN_ORDER, COLUMN_META } from "./biaColumns";

// C1/C2 — BIA workspace column chooser (extracted; identical behavior).
export const ColumnChooser = ({ colVis, toggleCol }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline" size="sm" data-testid="column-chooser-trigger">
        <Columns3 className="w-4 h-4 mr-1.5" /> Columns
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-56 max-h-[70vh] overflow-y-auto" data-testid="column-chooser-menu">
      <DropdownMenuLabel>Toggle columns</DropdownMenuLabel>
      <DropdownMenuSeparator />
      {COLUMN_ORDER.map((key) => (
        <DropdownMenuCheckboxItem
          key={key}
          checked={!!colVis[key]}
          onCheckedChange={() => toggleCol(key)}
          onSelect={(e) => e.preventDefault()}
          data-testid={`column-toggle-${key}`}
        >
          {COLUMN_META[key].label}
        </DropdownMenuCheckboxItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
